import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import DashboardNav from "../Components/DashboardHeader/DashboardNav";

import { AiFillCloseCircle, AiFillCheckCircle } from "react-icons/ai";
import { FaSearch, FaChevronDown } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import { addIron, updateIron, getIronFittingByUserId, getIronNotes } from "../Api/iron";
import { getUserList } from "../Api/auth";
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import Dropdown from '../Components/Dropdown/Dropdown';
import DropdownDot from '../Components/Dropdown Customer/DropdownDot';

function IronFittingEdit() {

    const soleDesign = [
        { value: '1', label: 'High', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Low', icon: '3' }
    ];

    const lieAngle = [
        { value: '1', label: 'Upright', icon: '1' },
        { value: '2', label: 'Standard', icon: '2' },
        { value: '3', label: 'Flat', icon: '3' }
    ];

    const shaftWeight = [
        { value: '1', label: 'Heavy', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Light', icon: '3' }
    ];

    const shaftFlex = [
        { value: '1', label: 'Hard', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Soft', icon: '3' }
    ];

    const shaftProfile = [
        { value: '1', label: 'High', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Low', icon: '3' }
    ];

    const gripSize = [
        { value: '1', label: 'Large', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Small', icon: '3' }
    ];

    const shaftLength = [
        { value: '1', label: 'Long', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Short', icon: '3' }
    ];

    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);
    const [show, setShow] = useState(false);
    const [notes, setNotes] = useState('');
    const [customerId, setCustomerId] = useState(null);
    const [filter_id, setFitting_id] = useState('');

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const params = useParams();

    function goBack() {
        window.history.back()
    }

    useEffect(() => {
        getIronData(params.id);

    }, [params.id]);

    const getIronData = async (id) => {//for get iron data by user id
        const data = {
            iron_id: id
        }
        getIronFittingByUserId(data).then((res) => {
            if (res.code === 200) {
                const ironData = res.data.data;
                if (ironData !== null) {
                    setInitCustomerClub(JSON.parse(ironData.initCustomerClub));
                    setInitCustomerTesting(JSON.parse(ironData.initCustomerTesting));
                    setNotes(ironData.notes);
                    setCustomerId(id);
                    setFitting_id(ironData._id);
                }
                else {
                    setCustomerId(id);
                    setFitting_id(ironData._id);
                }
            } else {
                alert(res.data.message);
            }
        }).catch((err) => {
            alert(err);
        });
    };

    const handleUpdateIron = async (event) => { //for update iron fitting data
        setApicall(true);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setApicall(false);
        } else {
            event.preventDefault();
            const user = localStorage.getItem("user");
            const userJson = JSON.parse(user);
            const data = {
                iron_id: params.id,
                user_id: customerId,
                fitting_id: userJson._id,
                filter_id: filter_id,
                initCustomerClub: JSON.stringify(initCustomerClub),
                initCustomerTesting: JSON.stringify(initCustomerTesting),
                notes: notes
            };

            setApicall(true);
            updateIron(data).then((res) => {
                if (res.code === 200) {
                    setApicall(false);
                    // setNotes('');
                    handleShow();
                } else {
                    alert(res.data.message);
                }
            }).catch((err) => {
                alert(err);
            }
            ).finally(() => {
                setApicall(false);
            });
            setValidated(true);
        }
    };

    const [initCustomerClub, setInitCustomerClub] = useState({
        soledesign: { value: '0', label: 'Select Bounce', icon: '0' },
        lieangle: { value: '0', label: 'Select Angle', icon: '0' },
        shaftweight: { value: '0', label: 'Select Weight', icon: '0' },
        shaftflex: { value: '0', label: 'Select Flex', icon: '0' },
        shaftprofile: { value: '0', label: 'Select Profile', icon: '0' },
        gripsize: { value: '0', label: 'Select SiZe', icon: '0' },
        shaftlength: { value: '0', label: 'Select Length', icon: '0' }
    });

    const [initCustomerTesting, setInitCustomerTesting] = useState({
        testingsoledesign: { value: '0', label: 'Select Bounce', icon: '0' },
        testinglieangle: { value: '0', label: 'Select Angle', icon: '0' },
        testingshaftweight: { value: '0', label: 'Select Weight', icon: '0' },
        testingshaftflex: { value: '0', label: 'Select Flex', icon: '0' },
        testingshaftprofile: { value: '0', label: 'Select Profile', icon: '0' },
        testinggripsize: { value: '0', label: 'Select SiZe', icon: '0' },
        testingshaftlength: { value: '0', label: 'Select Length', icon: '0' }
    });

    const handleInitCustomerClub = (name, value) => {
        setInitCustomerClub({
            ...initCustomerClub,
            [name]: value
        });
    };

    const handleInitCustomerTesting = (name, value) => {
        setInitCustomerTesting({
            ...initCustomerTesting,
            [name]: value
        });
    };

    useEffect(() => {
        console.log(initCustomerClub);
        console.log(initCustomerTesting);
    }, [initCustomerClub, initCustomerTesting]);


    return (
        <>
            <DashboardNav />
            <Modal
                show={show} // Show the modal when `show` is true
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="logo-modal">
                        <img src={require('../assets/images/logo_text.png')} alt="logo" />
                    </div>
                    <h3 className="text-center">Iron fitting data updated successfully</h3>
                    
                </Modal.Body>
            </Modal>
            <div className="dashboard-sec">
                <div className="container">
                    {customerId === null ? "" :
                        <>
                            <div className='d-flex justify-content-between align-items-center'>
                                <div className="middle-heading">
                                    <h3>Customer Club</h3>
                                </div>

                                <div className="middle-heading">
                                    <h3>Morgan Steven</h3>
                                </div>
                            </div>
                            <Dropdown formlable="Sole Design" options={soleDesign} name={"soledesign"} defaultSelected={initCustomerClub.soledesign} handleDropDownChange={handleInitCustomerClub} />
                            <Dropdown formlable="Lie Angle" options={lieAngle} name={"lieangle"} defaultSelected={initCustomerClub.lieangle} handleDropDownChange={handleInitCustomerClub} />
                            <Dropdown formlable="Shaft Weight" options={shaftWeight} name={"shaftweight"} defaultSelected={initCustomerClub.shaftweight} handleDropDownChange={handleInitCustomerClub} />
                            <Dropdown formlable="Shaft Flex" options={shaftFlex} name={"shaftflex"} defaultSelected={initCustomerClub.shaftflex} handleDropDownChange={handleInitCustomerClub} />
                            <Dropdown formlable="Shaft Profile" options={shaftProfile} name={"shaftprofile"} defaultSelected={initCustomerClub.shaftprofile} handleDropDownChange={handleInitCustomerClub} />
                            <Dropdown formlable="Grip Size" options={gripSize} name={"gripsize"} defaultSelected={initCustomerClub.gripsize} handleDropDownChange={handleInitCustomerClub} />
                            <Dropdown formlable="Shaft Length" options={shaftLength} name={"shaftlength"} defaultSelected={initCustomerClub.shaftlength} handleDropDownChange={handleInitCustomerClub} />
                            <div className="middle-heading">
                                <h3>Customer Testing</h3>
                            </div>
                            <DropdownDot formlable="Sole Design" options={soleDesign} name={"testingsoledesign"} defaultSelected={initCustomerTesting.testingsoledesign} handleDropDownChange={handleInitCustomerTesting} bgcolor="#ffffff" />
                            <DropdownDot formlable="Lie Angle" options={lieAngle} name={"testinglieangle"} defaultSelected={initCustomerTesting.testinglieangle} handleDropDownChange={handleInitCustomerTesting} bgcolor="#000000" />
                            <DropdownDot formlable="Shaft Weight" options={shaftWeight} name={"testingshaftweight"} defaultSelected={initCustomerTesting.testingshaftweight} handleDropDownChange={handleInitCustomerTesting} bgcolor="#1841EF" />
                            <DropdownDot formlable="Shaft Flex" options={shaftFlex} name={"testingshaftflex"} defaultSelected={initCustomerTesting.testingshaftflex} handleDropDownChange={handleInitCustomerTesting} bgcolor="#E050E5" />
                            <DropdownDot formlable="Shaft Profile" options={shaftProfile} name={"testingshaftprofile"} defaultSelected={initCustomerTesting.testingshaftprofile} handleDropDownChange={handleInitCustomerTesting} bgcolor="#8D25CD" />
                            <DropdownDot formlable="Grip Size" options={gripSize} name={"testinggripsize"} defaultSelected={initCustomerTesting.testinggripsize} handleDropDownChange={handleInitCustomerTesting} bgcolor="#DA3026" />
                            <DropdownDot formlable="Shaft Length" options={shaftLength} name={"testingshaftlength"} defaultSelected={initCustomerTesting.testingshaftlength} handleDropDownChange={handleInitCustomerTesting} bgcolor="#D78A31" />

                            <div className="middle-heading">
                                <h3>Club Comparison</h3>
                            </div>

                            <div className="form-box-section mb-3">
                                <div className="form-box-inner">
                                    <div className="compare-club-header">
                                        <div className="dashboard-form-lable">
                                            Sole Design
                                        </div>
                                        <div className="right-icon worang">
                                            <AiFillCloseCircle />
                                        </div>
                                    </div>

                                    <div className="form-btn-group">
                                        <div className="btn-alert">{initCustomerClub.soledesign.label}</div>
                                        <div className="btn-susses">{initCustomerTesting.testingsoledesign.label}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-box-section mb-3">
                                <div className="form-box-inner">
                                    <div className="compare-club-header">
                                        <div className="dashboard-form-lable">
                                            Lie Angle
                                        </div>
                                        <div className="right-icon right">
                                            <AiFillCheckCircle />
                                        </div>
                                    </div>

                                    <div className="form-btn-group">
                                        <div className="btn-alert">{initCustomerClub.lieangle.label}</div>
                                        <div className="btn-susses">{initCustomerTesting.testinglieangle.label}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-box-section mb-3">
                                <div className="form-box-inner">
                                    <div className="compare-club-header">
                                        <div className="dashboard-form-lable">
                                            Shaft Weight
                                        </div>
                                        <div className="right-icon">
                                            <AiFillCloseCircle />
                                        </div>
                                    </div>

                                    <div className="form-btn-group">
                                        <div className="btn-alert">{initCustomerClub.shaftweight.label}</div>
                                        <div className="btn-susses">{initCustomerTesting.testingshaftweight.label}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-box-section mb-3">
                                <div className="form-box-inner">
                                    <div className="compare-club-header">
                                        <div className="dashboard-form-lable">
                                            Shaft Flex
                                        </div>
                                        <div className="right-icon right">
                                            <AiFillCheckCircle />
                                        </div>
                                    </div>

                                    <div className="form-btn-group">
                                        <div className="btn-alert">{initCustomerClub.shaftflex.label}</div>
                                        <div className="btn-susses">{initCustomerTesting.testingshaftflex.label}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-box-section mb-3">
                                <div className="form-box-inner">
                                    <div className="compare-club-header">
                                        <div className="dashboard-form-lable">
                                            Shaft Profile
                                        </div>
                                        <div className="right-icon">
                                            <AiFillCloseCircle />
                                        </div>
                                    </div>

                                    <div className="form-btn-group">
                                        <div className="btn-alert">{initCustomerClub.shaftprofile.label}</div>
                                        <div className="btn-susses">{initCustomerTesting.testingshaftprofile.label}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-box-section mb-3">
                                <div className="form-box-inner">
                                    <div className="compare-club-header">
                                        <div className="dashboard-form-lable">
                                            Grip Size
                                        </div>
                                        <div className="right-icon right">
                                            <AiFillCheckCircle />
                                        </div>
                                    </div>

                                    <div className="form-btn-group">
                                        <div className="btn-alert">{initCustomerClub.gripsize.label}</div>
                                        <div className="btn-susses">{initCustomerTesting.testinggripsize.label}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-box-section mb-3">
                                <div className="form-box-inner">
                                    <div className="compare-club-header">
                                        <div className="dashboard-form-lable">
                                            Shaft Length
                                        </div>
                                        <div className="right-icon right">
                                            <AiFillCheckCircle />
                                        </div>
                                    </div>

                                    <div className="form-btn-group">
                                        <div className="btn-alert">{initCustomerClub.shaftlength.label}</div>
                                        <div className="btn-susses">{initCustomerTesting.testingshaftlength.label}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="middle-heading">
                                <h3>Fitter Notes</h3>
                            </div>

                            <div className="form-box-section mb-3">
                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" rows="8" value={notes} placeholder="Leave your note here..." onChange={(e) => setNotes(e.target.value)}></textarea>
                            </div>

                            <div className="sec-btn-group mt-4">
                                <button className="btn btn-cancel" onClick={goBack}>Exit without saving</button>
                                {
                                    apicall ? (
                                        <button className="btn btn-save"><Spinner animation="border" className="border-black" /> </button>
                                    ) : (
                                        <button onClick={handleUpdateIron} className="btn btn-save">Update Iron Data</button>
                                    )
                                }
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    );
}

export default IronFittingEdit;